import isEmpty from 'lodash/isEmpty';
import pickBy from 'lodash/pickBy';
import {Record} from 'immutable';
import {requiredMessage} from 'utils/const';

/**
 * Scoring Schemes for review type questions. Note that these are different than
 * the scorecard scoring schemes
 * @link ScoringScheme
 */
export const QUESTION_TYPE_TYPE = Object.freeze({
  TextArea: 'TextArea',
  TextField: 'TextField',
  YesNo: 'YesNo',
  PassFail: 'PassFail',
  OneToThree: 'OneToThree',
  OneToFive: 'OneToFive',
  ContentDetail: 'ContentDetail',
});

export const RESPONDENT_TYPE = Object.freeze({
  REP: 'REP',
  COACH: 'COACH',
});

export function validate(question) {
  const text = isEmpty(question.text) && requiredMessage;
  const type = question.type == null && requiredMessage;

  return pickBy({
    text,
    type,
  });
}

export default class CoachingReviewTypeQuestion extends Record({
  id: null,
  text: '',
  type: QUESTION_TYPE_TYPE.OneToFive,
  weight: 0,
  coachNotes: '',
  respondent: RESPONDENT_TYPE.COACH,
  optional: true,
}) {
  isText() {
    return this.type === QUESTION_TYPE_TYPE.TextArea || this.type === QUESTION_TYPE_TYPE.TextField;
  }
}
